import React from 'react'
import Dropdown from '@dd3tech/wiggui/Dropdown'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import Input from '@dd3tech/wiggui/Input'
import PillButton from '@dd3tech/wiggui/PillButton'
import Text from '@dd3tech/wiggui/Text'

interface ICustomDropdown {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  placeholder: string
  menuTitle: string
  renderOptions: any
  onReset: () => void
  withSearch: boolean
  searchVal: string
  setSearchVal: (val: string) => void
  activeFilters: number
  onConfirm: () => void
  onClose: () => void
  withoutFooter?: boolean
  dropdownClassName?: string
  optionsContainerClassNames?: string
  pillButtonClassName?: string
  pillButtonContainerClassName?: string
  placeholderIcon?: string
  withoutHeader?: boolean
}

export const CustomDropdown = ({
  isOpen,
  setIsOpen,
  placeholder,
  menuTitle,
  renderOptions,
  onReset,
  withSearch,
  searchVal,
  setSearchVal,
  activeFilters,
  onConfirm,
  onClose,
  withoutFooter = false,
  dropdownClassName,
  optionsContainerClassNames,
  pillButtonClassName,
  pillButtonContainerClassName,
  placeholderIcon,
  withoutHeader
}: ICustomDropdown) => {
  return (
    <Dropdown
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClose={() => {
        setSearchVal('')
        onClose()
      }}
    >
      <Dropdown.Trigger className="flex h-full items-center">
        <div className={`relative ${pillButtonContainerClassName || ''}`}>
          <PillButton
            className={`max-h-[36px] max-w-[36px] !border !border-surface-strokes !p-[10px] font-normal ${
              pillButtonClassName || ''
            }`}
            isActive={isOpen}
            rightIcon={
              !placeholderIcon && (
                <GoogleIcon
                  className="text-base"
                  name={isOpen ? 'expand_less' : 'expand_more'}
                />
              )
            }
          >
            {placeholderIcon ? (
              <GoogleIcon className="text-base " name={placeholderIcon} />
            ) : (
              placeholder
            )}
          </PillButton>
          {activeFilters > 0 && (
            <div className="absolute min-w-[24px] min-h-[24px] text-center rounded-full px-2 py-1 bg-surface-bg-black text-white text-[0.625rem] font-bold right-0 -top-2">
              {activeFilters}
            </div>
          )}
        </div>
      </Dropdown.Trigger>
      <Dropdown.Menu
        buttomSheetClassName="p-4 flex flex-col items-center justify-center w-full gap-4"
        className={`w-full min-w-[350px] max-h-[341px] p-4 flex flex-col gap-4 z-10 ${
          dropdownClassName || ''
        }`}
      >
        {!withoutHeader && (
          <div className="flex justify-between w-full">
            <Text className="text-base font-semibold">{menuTitle}</Text>
            <div onClick={() => setIsOpen(false)}>
              <GoogleIcon name="close" className="cursor-pointer" />
            </div>
          </div>
        )}
        {withSearch && (
          <Input
            classNameContainer="w-fit min-w-[300px] max-h-[52px]"
            className="w-full h-[52px]"
            classNameLabel="text-secondary whitespace-nowrap truncate"
            labelText="Buscar"
            name="search"
            leftIcon="search"
            value={searchVal}
            onChange={(event) => setSearchVal(event?.target?.value)}
          />
        )}
        <div
          className={`flex flex-col gap-4 max-h-[192px] scroll-auto overflow-y-auto w-full ${
            optionsContainerClassNames || ''
          }`}
        >
          {renderOptions}
        </div>
        {!withoutFooter && (
          <Dropdown.Footer
            className="!p-0"
            onReset={onReset}
            onConfirm={onConfirm}
          />
        )}
      </Dropdown.Menu>
    </Dropdown>
  )
}
